import VueApp from "../../03-fragments/vueApp/VueApp.js";

const processor = function(data) {

    if (typeof data !== "object" || typeof data.item !== "object" || typeof data.item.data !== "object") {
        console.warn(`projektPage: Page with "${data.uid}" not found!`);
        window.location.replace("/404");
        return;
    }

    return data;

}

VueApp.init({
    id: "projectPage",
    processor: processor,
    settings: {
        customType: "project-story",
        root: "/projekte",
    },
    data: {
    },
});
